import { FC, useState } from 'react'
import { Divider, Input, Radio, Alert, message } from 'antd'
import type { RadioChangeEvent } from 'antd'
import { SuccessMessage } from '../../components'
import { CommonBlock } from '../../components'
import {
    DropdownSelector,
    ImportButton,
    TagSelector,
    DocumentsBlockUI,
    IconButton,
} from '../../../ui'
import style from './style.m.less'
import { useTranslation } from 'react-i18next'

const { TextArea } = Input

const userTypes = [
    { value: 'ООО Ромашка', id: '55677a62-97a0-47d2-8b8f-d57abe52f591' },
    { value: 'ООО Фиалка', id: '7c23e409-c4c6-46dc-ad08-156c3456610d' },
]

interface IGeneratorLayout {
    type: 'generator' | 'create' | 'profile'
}

const GeneratorLayout: FC<IGeneratorLayout> = ({ type }) => {
    const { t } = useTranslation()

    const isCreate = type === 'create' ? true : undefined

    const [value, setValue] = useState(1)

    const handleConfirm = () => {
        message.success({
            content: (
                <SuccessMessage
                    header={t('editMyProfile.success')}
                    message={`ЗГО СЭС “Абаканская” ${t('editMyProfile.created')}`}
                />
            ),
            icon: <></>,
        })
    }

    const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value)
    }

    return (
        <>
            <CommonBlock
                label={t('editMyProfile.marketEE')}
                select={
                    <Radio.Group onChange={onChange} value={value} className={style.radio}>
                        <Radio value={1}>{t('editMyProfile.retail')}</Radio>
                        <Radio value={2}>{t('editMyProfile.wholesale')}</Radio>
                    </Radio.Group>
                }
            />
            <Divider />
            <CommonBlock
                label={t('editMyProfile.name')}
                select={
                    <Input
                        placeholder={isCreate && t('editMyProfile.namePlaceholder')}
                        className={style.inputLong}
                    />
                }
            />
            <CommonBlock
                margin
                label={t('editMyProfile.codeGO')}
                select={
                    <Input
                        placeholder={isCreate && t('editMyProfile.codeGOPlaceholder')}
                        className={style.input}
                    />
                }
            />
            <Divider />
            <CommonBlock
                label={t('editMyProfile.tco')}
                select={
                    <DropdownSelector
                        placeholder={isCreate ? 'Выберите из списка' : 'Введите название ГО'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <ImportButton
                noMargin
                customStyle={{ marginTop: '8px', marginLeft: '216px' }}
                value={t('editMyProfile.fillManually')}
            />
            <CommonBlock
                label={t('editMyProfile.gp')}
                margin
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <ImportButton
                noMargin
                customStyle={{ marginTop: '8px', marginLeft: '216px' }}
                value={t('editMyProfile.fillManually')}
            />
            <Divider />
            <CommonBlock
                label={t('editMyProfile.placeGO')}
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <div className={style.blockGroup}>
                <div>
                    <div>{t('editMyProfile.subject')}</div>
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '492px' }}
                    />
                </div>
                <div>
                    <div>{t('editMyProfile.index')}</div>
                    <Input className={style.inputTiny} placeholder="_ _ _ _ _ _" />
                </div>
            </div>
            <div className={style.blockGroup}>
                <div>
                    <div>{t('editMyProfile.locality')}</div>
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '296px' }}
                    />
                </div>
                <div>
                    <div>{t('editMyProfile.city')}</div>
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '296px' }}
                    />
                </div>
            </div>
            <div className={style.blockGroup}>
                <div>
                    <div>{t('editMyProfile.street')}</div>
                    <Input
                        placeholder={isCreate && 'Введите название улицы'}
                        className={style.inputShort}
                    />
                </div>
                <div>
                    <div>{t('editMyProfile.house')}</div>
                    <Input className={style.inputTiny} />
                </div>
                <div>
                    <div>{t('editMyProfile.block')}</div>
                    <Input className={style.inputTiny} />
                </div>
                <div>
                    <div>{t('editMyProfile.building')}</div>
                    <Input className={style.inputTiny} />
                </div>
            </div>
            <div className={style.blockGroup}>
                <div>
                    <div>{t('editMyProfile.lat')}</div>
                    <Input
                        className={style.inputMiddle}
                        placeholder={t('editMyProfile.specifyLatitude')}
                    />
                </div>
                <div>
                    <div>{t('editMyProfile.lng')}</div>
                    <Input
                        className={style.inputMiddle}
                        placeholder={t('editMyProfile.specifyLongitude')}
                    />
                </div>
            </div>
            <div className={style.blockGroup}>
                <div>
                    <div>{t('editMyProfile.addressMore')}</div>
                    <TextArea className={style.textArea} rows={4} />
                </div>
            </div>
            <Divider />
            <CommonBlock
                label={t('editMyProfile.categoryGO')}
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <CommonBlock
                label={t('editMyProfile.fuelType')}
                select={<TagSelector customStyle={{ marginLeft: '16px', width: '400px' }} />}
            />
            <CommonBlock
                margin
                label={t('editMyProfile.ustPower')}
                select={<Input className={style.input} />}
            />
            <CommonBlock
                margin
                label={t('editMyProfile.manufMode')}
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <CommonBlock
                margin
                label={t('editMyProfile.ownerBase')}
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <CommonBlock
                margin
                label={t('editMyProfile.ownerGO')}
                select={<Input className={style.input} />}
            />
            <CommonBlock
                margin
                label={t('editMyProfile.support')}
                select={
                    <DropdownSelector
                        placeholder={isCreate && 'Выберите из списка'}
                        options={userTypes}
                        customStyle={{ width: '400px', marginLeft: '16px' }}
                    />
                }
            />
            <Divider />
            <DocumentsBlockUI type={type} />
            {type === 'create' && (
                <>
                    <Divider />
                    <Alert
                        message={
                            <div>
                                <div className={style.alertHeader}>
                                    {t('editMyProfile.addGOAlert')}
                                </div>
                                <div className={style.alertText}>
                                    Баланс платежного счета: 230 000 ₽
                                </div>
                            </div>
                        }
                        className={style.alert}
                        type="warning"
                        showIcon
                    />
                    <IconButton onClick={handleConfirm} customStyle={{ marginTop: '32px' }}>
                        {t('editMyProfile.submitData')}
                    </IconButton>
                </>
            )}
        </>
    )
}

export default GeneratorLayout
